import { Controller } from "@hotwired/stimulus"

// Scales the ID card wrapper to fit within its parent container.
// Attach to the wrapper element that has a fixed intrinsic width.
//
// Usage:
//   <div data-controller="id-card-scale" data-id-card-scale-width-value="568"
//        style="transform-origin: top left; width: 568px;">
//
// The controller auto-detects the parent width and applies CSS transform: scale()
// so the card fits. A ResizeObserver re-scales when the container changes size
// (e.g. drawer animating open, window resize).
export default class extends Controller {
  static values = { width: { type: Number, default: 568 } }

  connect() {
    this.scale()

    this.resizeObserver = new ResizeObserver(() => this.scale())
    this.resizeObserver.observe(this.element.parentElement)

    this.mutationObserver = new MutationObserver(() => this.scale())
    this.mutationObserver.observe(this.element, { attributes: true, attributeFilter: ["class"], subtree: true })
  }

  disconnect() {
    if (this.resizeObserver) this.resizeObserver.disconnect()
    if (this.mutationObserver) this.mutationObserver.disconnect()
  }

  scale() {
    const parent = this.element.parentElement
    if (!parent) return

    const available = parent.clientWidth
    const cardWidth = this.widthValue

    this.element.style.transform = ''
    parent.style.height = ''

    if (available > 0 && available < cardWidth) {
      const ratio = available / cardWidth
      this.element.style.transform = `scale(${ratio})`
      parent.style.height = `${this.element.scrollHeight * ratio}px`
    }
  }
}
